export default __webpack_public_path__ + "static/media/sactx-1-2048x2048-ETC2-Sprites-ccb1f723 3.cbe52822.png";